/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var ActivePageSection = require('common/util/ActivePageSection');

var GetAllEntityLookups = require('../../common/services/GetAllEntityLookups');

var COCInternalCreateNewEventView = require('../views/COCInternalCreateNewEventView');
var GetAllEventLookups = require('../../common/services/GetAllEventLookups');
var GetUserInformationForRole = require('common/services/GetUserInformationForRole');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetAllEventLookups(), GetUserInformationForRole('COC - User'), GetAllEntityLookups())
    .done(function(eventLookups, cocUsers, entityLookups) {
      NavUtils.navigate('coc/event/new');
      Scaffold.content.show(
        new COCInternalCreateNewEventView({
          model: new Backbone.Model({
            eventTypes: eventLookups.eventTypes,
            programs: eventLookups.programs,
            cocUsers: cocUsers,
            aarpVolunteers: eventLookups.aarpVolunteers,
            targetAudiences: eventLookups.targetAudiences,
            eventFormats: eventLookups.eventFormats,
            entityTypes: entityLookups.entityTypes,
            organizationTypes: entityLookups.organizationTypes
          })
        })
      );

      ActivePageSection.empty();
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
